module.exports = __webpack_public_path__ + "static/media/wave-bg.0471139d.svg";